// このファイルは pnpm run optimize-images で生成されます。

export type ImageMetadata = {
  src: string;
  webp?: string;
  width: number;
  height: number;
};

export const IMAGE_METADATA: Record<string, ImageMetadata> = {
  '/img/childcare/nursery_room_01.jpg': {
    src: '/img/childcare/nursery_room_01.jpg',
    webp: '/img/childcare/nursery_room_01.webp',
    width: 1200,
    height: 800,
  },
  '/img/childcare/nursery-room_02_2025-08.jpg': {
    src: '/img/childcare/nursery-room_02_2025-08.jpg',
    webp: '/img/childcare/nursery-room_02_2025-08.webp',
    width: 1620,
    height: 1080,
  },
  '/img/events/iao/iao.jpg': {
    src: '/img/events/iao/iao.jpg',
    webp: '/img/events/iao/iao.webp',
    width: 980,
    height: 654,
  },
  '/img/exterior/hospital-exterior-2025-08.jpg': {
    src: '/img/exterior/hospital-exterior-2025-08.jpg',
    webp: '/img/exterior/hospital-exterior-2025-08.webp',
    width: 1620,
    height: 1080,
  },
  '/img/facilities/air_conditioner.jpg': {
    src: '/img/facilities/air_conditioner.jpg',
    webp: '/img/facilities/air_conditioner.webp',
    width: 1080,
    height: 720,
  },
  '/img/facilities/ceiling-monitor.jpg': {
    src: '/img/facilities/ceiling-monitor.jpg',
    webp: '/img/facilities/ceiling-monitor.webp',
    width: 600,
    height: 338,
  },
  '/img/facilities/cerec-machine01.jpg': {
    src: '/img/facilities/cerec-machine01.jpg',
    webp: '/img/facilities/cerec-machine01.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/counseling-room.jpg': {
    src: '/img/facilities/counseling-room.jpg',
    webp: '/img/facilities/counseling-room.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/examining-seat.jpg': {
    src: '/img/facilities/examining-seat.jpg',
    webp: '/img/facilities/examining-seat.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/extraoral-vacuum.jpg': {
    src: '/img/facilities/extraoral-vacuum.jpg',
    webp: '/img/facilities/extraoral-vacuum.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/large-monitor.jpg': {
    src: '/img/facilities/large-monitor.jpg',
    webp: '/img/facilities/large-monitor.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/payment-machine.jpg': {
    src: '/img/facilities/payment-machine.jpg',
    webp: '/img/facilities/payment-machine.webp',
    width: 400,
    height: 600,
  },
  '/img/facilities/reception-desk.jpg': {
    src: '/img/facilities/reception-desk.jpg',
    webp: '/img/facilities/reception-desk.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/restroom-baby-crib.jpg': {
    src: '/img/facilities/restroom-baby-crib.jpg',
    webp: '/img/facilities/restroom-baby-crib.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/sterilizer-lisa.jpg': {
    src: '/img/facilities/sterilizer-lisa.jpg',
    webp: '/img/facilities/sterilizer-lisa.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/surgical_microscope.jpg': {
    src: '/img/facilities/surgical_microscope.jpg',
    webp: '/img/facilities/surgical_microscope.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/wash-stand.jpg': {
    src: '/img/facilities/wash-stand.jpg',
    webp: '/img/facilities/wash-stand.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/wheelchair-accessible-restroom.jpg': {
    src: '/img/facilities/wheelchair-accessible-restroom.jpg',
    webp: '/img/facilities/wheelchair-accessible-restroom.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/wheelchair-ramp.jpg': {
    src: '/img/facilities/wheelchair-ramp.jpg',
    webp: '/img/facilities/wheelchair-ramp.webp',
    width: 600,
    height: 400,
  },
  '/img/facilities/wheelchair.jpg': {
    src: '/img/facilities/wheelchair.jpg',
    webp: '/img/facilities/wheelchair.webp',
    width: 600,
    height: 400,
  },
  '/img/group-photos/group-photo-20260629.jpg': {
    src: '/img/group-photos/group-photo-20260629.jpg',
    webp: '/img/group-photos/group-photo-20260629.webp',
    width: 1920,
    height: 1280,
  },
  '/img/index/main_clipped.jpg': {
    src: '/img/index/main_clipped.jpg',
    webp: '/img/index/main_clipped.webp',
    width: 892,
    height: 646,
  },
  '/img/items/AI_denture.jpg': {
    src: '/img/items/AI_denture.jpg',
    webp: '/img/items/AI_denture.webp',
    width: 300,
    height: 200,
  },
  '/img/items/CI_denture.jpg': {
    src: '/img/items/CI_denture.jpg',
    webp: '/img/items/CI_denture.webp',
    width: 300,
    height: 200,
  },
  '/img/items/clear_denture.jpg': {
    src: '/img/items/clear_denture.jpg',
    webp: '/img/items/clear_denture.webp',
    width: 300,
    height: 200,
  },
  '/img/items/ems/AFPM-with-long-cord-litho.jpg': {
    src: '/img/items/ems/AFPM-with-long-cord-litho.jpg',
    webp: '/img/items/ems/AFPM-with-long-cord-litho.webp',
    width: 969,
    height: 968,
  },
  '/img/items/ems/DR-207_JP_rev_C_GBT-Compass-1024x727.jpg': {
    src: '/img/items/ems/DR-207_JP_rev_C_GBT-Compass-1024x727.jpg',
    webp: '/img/items/ems/DR-207_JP_rev_C_GBT-Compass-1024x727.webp',
    width: 1024,
    height: 727,
  },
  '/img/logo.png': {
    src: '/img/logo.png',
    width: 426,
    height: 110,
  },
  '/img/ogp.jpg': {
    src: '/img/ogp.jpg',
    webp: '/img/ogp.webp',
    width: 1200,
    height: 630,
  },
  '/img/orthodontic/flow_01.jpg': {
    src: '/img/orthodontic/flow_01.jpg',
    webp: '/img/orthodontic/flow_01.webp',
    width: 980,
    height: 653,
  },
  '/img/orthodontic/flow_02.jpg': {
    src: '/img/orthodontic/flow_02.jpg',
    webp: '/img/orthodontic/flow_02.webp',
    width: 980,
    height: 966,
  },
  '/img/orthodontic/flow_03.jpg': {
    src: '/img/orthodontic/flow_03.jpg',
    webp: '/img/orthodontic/flow_03.webp',
    width: 980,
    height: 678,
  },
  '/img/profile/dr_kawaji.jpg': {
    src: '/img/profile/dr_kawaji.jpg',
    webp: '/img/profile/dr_kawaji.webp',
    width: 400,
    height: 600,
  },
  '/img/profile/dr_kobayashi.jpg': {
    src: '/img/profile/dr_kobayashi.jpg',
    webp: '/img/profile/dr_kobayashi.webp',
    width: 400,
    height: 600,
  },
  '/img/profile/dr_miyashita.jpg': {
    src: '/img/profile/dr_miyashita.jpg',
    webp: '/img/profile/dr_miyashita.webp',
    width: 461,
    height: 691,
  },
  '/img/profile/dr_yasukawa.jpg': {
    src: '/img/profile/dr_yasukawa.jpg',
    webp: '/img/profile/dr_yasukawa.webp',
    width: 400,
    height: 600,
  },
  '/img/recruitment/dr-maruhashi.jpg': {
    src: '/img/recruitment/dr-maruhashi.jpg',
    webp: '/img/recruitment/dr-maruhashi.webp',
    width: 653,
    height: 980,
  },
  '/img/recruitment/during_training.jpg': {
    src: '/img/recruitment/during_training.jpg',
    webp: '/img/recruitment/during_training.webp',
    width: 1080,
    height: 810,
  },
  '/img/recruitment/event/20250420/20250420-01.jpg': {
    src: '/img/recruitment/event/20250420/20250420-01.jpg',
    webp: '/img/recruitment/event/20250420/20250420-01.webp',
    width: 1028,
    height: 771,
  },
  '/img/recruitment/event/20250420/20250420-02.jpg': {
    src: '/img/recruitment/event/20250420/20250420-02.jpg',
    webp: '/img/recruitment/event/20250420/20250420-02.webp',
    width: 1028,
    height: 771,
  },
  '/img/scenery/staff-chatting.jpg': {
    src: '/img/scenery/staff-chatting.jpg',
    webp: '/img/scenery/staff-chatting.webp',
    width: 600,
    height: 400,
  },
  '/img/slideshow/interior_sketch_16x9.jpg': {
    src: '/img/slideshow/interior_sketch_16x9.jpg',
    webp: '/img/slideshow/interior_sketch_16x9.webp',
    width: 2700,
    height: 1519,
  },
  '/img/slideshow/view_from_outside_spring.jpg': {
    src: '/img/slideshow/view_from_outside_spring.jpg',
    webp: '/img/slideshow/view_from_outside_spring.webp',
    width: 1024,
    height: 576,
  },
  '/img/vehicles/home-visitation-car-01-resized.jpg': {
    src: '/img/vehicles/home-visitation-car-01-resized.jpg',
    webp: '/img/vehicles/home-visitation-car-01-resized.webp',
    width: 1024,
    height: 768,
  },
};
